import { WizardBasketData } from '@wizard/models';

export const createEmptyWizardBasketData = (): WizardBasketData => {
  return {
    reports: [],
    semantics: [],
    datamarts: [],
    views: [],
    tables: []
  };
};
